import { render, staticRenderFns } from "./Estudante.vue?vue&type=template&id=bb9e5010&scoped=true&"
import script from "./Estudante.vue?vue&type=script&lang=js&"
export * from "./Estudante.vue?vue&type=script&lang=js&"
import style0 from "./Estudante.vue?vue&type=style&index=0&id=bb9e5010&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9e5010",
  null
  
)

export default component.exports